export default __webpack_public_path__ + "f6f46401a1bd5475c5324e9d80e89010.png";